export const Endpoints = {
    AUTH: {
        LOGIN: `/admin/auth/login`,
        FORGET_PASSWORD: `/admin/auth/forgot_password`,
        RESET_PASSWORD: `/admin/auth/reset_password`,
        VERIFY_OTP: `/admin/auth/verify_otp`,
        RESENT_OTP: `/admin/auth/resend_otp`,
        LOGOUT: `/admin/auth/logout`
    },
    NON_AUTH: {
        DASHBOARD_CHART_DATA: '/admin/user/dashboardEarnings',
        TOGGLE_SUBSCRIPTION_FREE_PLAN: '/admin/user/markFreePlan',
        FAQ_LIST: '/common/questions',
        ADD_FAQ: '/admin/common/question',
        BOARDING: '/admin/boarding',
        BOARDING_ID: '/admin/boarding',
        POLICY: '/common/common_content',
        POLICY_UPDATE: '/admin/common/common_content',
        USER_TABLE: '/admin/user/list',
        DASHBOARD: '/admin/user/dashboard',
        USER_DETAIL: '/admin/user/details',
        STATUS: '/user/auth/delete_account',
        DELETE_USER: '/user/auth/delete_accounts',
        CONTACT_US: '/admin/contactus/list',
        DELETE_CONTACT: '/admin/contactus/delete',
        REPLY_CONTACT: '/admin/contactus/reply',
        CHANGE_PASSWORD: '/admin/auth/change_password',
        UPDATE_PROFILE:'/admin/auth/profile',
    },
}